import { PropsWithChildren } from "react";
import DefaultHeader from "../DefaultHeader";
import { MarketplaceProvider } from "../../marketplace/context";
import AccountGate from "./AccountGate";

const HeaderLayout = ({ children }: PropsWithChildren) => {
  return (
    <MarketplaceProvider>
      <AccountGate>
        <div className="min-h-screen bg-ink-50 text-ink-900">
          <DefaultHeader />
          <main className="mx-auto max-w-7xl px-6 py-10 anim-in">
            {children}
          </main>
        </div>
      </AccountGate>
    </MarketplaceProvider>
  );
};

export default HeaderLayout;
